import { Lightning, Log } from '@lightningjs/sdk'
import { Helper } from '../../lib/helper'
import ParentalButton from '../../ui-elements/parental-button'
import { jwtDecode } from 'jwt-decode'

export default class GetCodeGoogle extends Lightning.Component {

    polingIntv: any
    codeData: any
    interval = 0
    accessToken: any
    status = 'waiting'
    instructions = (uri) => `Next, visit ${uri} on your desktop or smartphone and enter this code`
    userCode = (code) => `USER CODE: ${code}`
    private clientId = process.env.APP_GOOGLE_OAUTH_CLIENT_ID
    private clientSecret = process.env.APP_GOOGLE_OAUTH_CLIENT_SECRET
    abortAjax: any
    userDetails: any

    static override _template() {
        return {
            w: 1920,
            h: 1080,
            color: 0xff000000,
            Container: {
                x: (w) => w / 2,
                y: (h) => h / 2,
                mount: 0.5,
                w: 1000,
                h: 400,
                rect: true,
                color: 0xff000000,
                flex: { direction: 'column', margin:10},
                Title: {
                    //flex: { direction: 'row', justifyContent: 'space-between', alignItems:'center'},
                    w:1000, 
                    h:90,
                    Label: {
                        y:20,
                        x:20,
                        text: { text: 'Sign in with Google', fontSize: 30, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff }
                    },
                    Expires: {
                        y:20,
                        x: 960,
                        mountX:1,
                        text: { text: '', fontSize: 30, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff }
                    },
                },
                Body: {
                    rect: true,
                    color: 0xff222222,
                    w: (w) => w,
                    h: 400,
                    flex: { direction: 'column', margin:10},
                    Instruction: {
                        y:20, x:20,
                        h: 80,
                        text: { text: 'Loading ...', fontSize: 24, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff, wordWrapWidth: 900, maxLines: 2 }
                    },
                    Usercode: {
                        x:20,
                        y:60,
                        h: 60,
                        text: { text: '', fontSize: 40, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff }
                    },
                    ButtonWrapper: {
                        y: 80,
                        h: 90,
                        flexItem: { alignSelf: 'center'},
                        CreateBtn: {
                            mount: 0.5,
                            type: ParentalButton,
                            label: 'Continue to create pin',
                            icon: null,
                            w: 400
                        },
                        visible: false,
                    }
                }
            },
        }
    }

    override _init(): void {
        this.getGoogleCode()
    }

    updateScreen() {
        const { verification_url, user_code, interval, expires_in } = this.codeData

        this.tag('Instruction').text.text = this.instructions(verification_url)
        this.tag('Usercode').text.text = this.userCode(user_code)
        this.startPolingTimer(interval, expires_in)
    }

    getGoogleCode() {
        this.tag('Instruction').text.text = 'Loading ...'
        this.tag('Usercode').text.text = ''
        this.tag('Expires').text.text = ''
        this.abortAjax = $.ajax({
            type: "POST",
            url: 'https://oauth2.googleapis.com/device/code',
            data: {
                client_id: this.clientId,
                scope: 'openid email profile'
            },
            cache: false,
            beforeSend: () => {
                //helper.preloaderDisplay('show');
            },
            success: (data) => {
                this.codeData = data
                Log.info('getGoogleCode Success:', this.codeData)
                this.updateScreen()
            }
        });

    }

    updateSuccess(data) {
        this.tag('Label').text.text = 'Welcome ' + data.name
        this.tag('Instruction').text.text = 'Press Ok to create PIN'
        //this.tag('CreateBtn').text.text = 'Continue to create pin'
        this.tag('ButtonWrapper').visible = true
        this.tag('Usercode').text.text = ''
        this.tag('Expires').text.text = ''
        this.status = 'success'
    }

    startPolingTimer(interval, expires) {
        Log.info('startPolingTimer:', this.codeData.device_code)
        let secCnt = 0
        this.polingIntv = setInterval(() => {
            secCnt++;
            this.tag('Expires').text.text = `Expires in ${Helper.secondsToDisplayReadyTime(expires - secCnt)}`
            if (secCnt % interval == 0) {
                $.ajax({
                    type: "POST",
                    url: 'https://oauth2.googleapis.com/token',
                    data: {
                        client_id: this.clientId,
                        client_secret: this.clientSecret,
                        device_code: this.codeData.device_code,
                        grant_type: `urn:ietf:params:oauth:grant-type:device_code`
                    },
                    cache: false,
                    beforeSend: function () {

                    },
                    success: (data) => {
                        const resp = data;
                        if (resp.error) {
                            Log.info('waiting for User : ',resp)
                            if (resp.error.code == 428) {
                                Log.info('waiting for User : ', resp)
                                this.stopPolingTimer()
                                this.signal('codeScreen')
                            }
                        } else {
                            Log.info('User Authenticated: ',resp)
                            this.accessToken = resp.access_token;
                            this.userDetails = resp
                            this.getGoogleDetails();
                            this.stopPolingTimer();
                        }
                    },
                    error: function (e) {
                        console.log('error: ' + e);
                    }
                });
            }
        }, (1000));
    }

    stopPolingTimer() {
        clearInterval(this.polingIntv);
    }

    getGoogleDetails() {
        const user_profile = jwtDecode(this.userDetails.id_token)

        const user_id = user_profile["sub"];

        // These values are available when you request the "profile" and "email" scopes.
        const user_email = user_profile["email"];
        const email_verified = user_profile["email_verified"];
        const user_name = user_profile["name"];
        const user_birthdate = user_profile["birthdate"];
        const user_photo_url = user_profile["picture"];
        const user_given_name = user_profile["given_name"];
        const user_family_name = user_profile["family_name"];
        const user_locale = user_profile["locale"];
        Log.info('UserDetails: ',  user_id, user_name, user_birthdate)

        Log.info('profile: ', user_profile);
        this.updateSuccess(user_profile)
        // $.ajax({
        //     url: "https://people.googleapis.com/v1/people/me",
        //     headers: {
        //         Authorization: "Bearer " + this.userDetails.access_token,
        //         Accept: 'application/json'
        //     },
        //     data: {
        //         personFields: "names,emailAddresses,ageRanges,birthdays"
        //     },
        //     success: function (data) {
        //         console.log("People API User age range:", data);
        //     },
        //     error: function (xhr) {
        //         console.error("People API error:", xhr.responseText);
        //     }
        // });
        // $.ajax({
        //     type: "GET",
        //     url: 'https://www.googleapis.com/auth/userinfo.profile?access_token=' + this.accessToken + '&fields=name',
        //     dataType: "text",
        //     cache: false,
        //     beforeSend: function () {

        //     },
        //     success: (data) => {
        //         const resp = JSON.parse(data);
        //         Log.info('profile: ', resp);
        //         this.updateSuccess(resp)
        //         // //const successText = this.getProfileTemplate(resp.name);
        //         // $('#code-screen-wrapper').empty();
        //         // $('#code-screen-wrapper').append(successText);

        //     },
        //     error: function (e) {
        //         console.log('error: ' + e);
        //     }
        // });
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
        return true
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        this.signal('back')
        return true
    }

    override _getFocused(): Lightning.Component | null | undefined {
        return this.tag('CreateBtn')
    }

    override _handleEnter(e: KeyboardEvent): boolean | void {
        if (this.status == 'success') {
            this.signal('createPin')
        }
        return true
    }

    _handleClick(e: KeyboardEvent): boolean | void {
        if (this.status == 'success') {
            this.signal('createPin')
        }
        return true
    }

    override _detach(): void {
        this.abortAjax && this.abortAjax.abort()
        this.stopPolingTimer()
    }

}